import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './DetailedResultsPage.css';
import RichText from '../../components/common/RichText';

interface Result {
  totalQuestions: number;
  correctAnswers: number;
  incorrectAnswers: number;
  skippedQuestions: number;
  percentage: number;
  detailedResults: Array<{
    questionId: string;
    question: string;
    options: string[];
    correctAnswer: string;
    explanationToAnswer: string;
    userAnswer: string | null;
  }>;
  subject: string;
  feedback: string;
  topics: string[];
  Botfeedback: string;
  audioBase64: string;
}

const DetailedResultsPage: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { result } = (location.state as { result: Result }) || {};

  if (!result) {
    return <div className="details-error">No results available. Please try again.</div>;
  }

  return (
    <div className="details-page">
      <div className="details-container">
        <h1 className="details-title">📋 Detailed Quiz Results</h1>
        <h2>{result.subject} Quiz</h2>
        <div className="detailed-details">
          {result.detailedResults.map((item, index) => (
            <div key={item.questionId} className="detailed-result-item">
              <h3>Question {index + 1}</h3>
              <p><strong>Question:</strong> <RichText inline text={item.question} /></p>
              <p><strong>Options:</strong></p>
              <ul>
                {item.options.map((option, idx) => (
                  <li key={idx}><RichText inline text={option} /></li>
                ))}
              </ul>
              <p><strong>Correct Answer:</strong> <RichText inline text={item.correctAnswer} /></p>
              <p>
                <strong>Your Answer:</strong>{' '}
                {item.userAnswer ? <RichText inline text={item.userAnswer} /> : 'Skipped'}
                {item.userAnswer === item.correctAnswer ? (
                  <span className="correct"> ✓ Correct</span>
                ) : item.userAnswer ? (
                  <span className="incorrect"> ✗ Incorrect</span>
                ) : (
                  <span className="skipped"> - Skipped</span>
                )}
              </p>
              {item.explanationToAnswer && (
                <p>
                  <strong>Explanation:</strong> {item.explanationToAnswer}
                </p>
              )}
            </div>
          ))}
        </div>
        <button className="back-button" onClick={() => navigate('/results', { state: { result } })}>
          Back to Summary
        </button>
      </div>
    </div>
  );
};

export default DetailedResultsPage;
